module.exports = __webpack_public_path__ + "media/images/brand/diners-6d7b85d71514f4792952d8dd35717655.png";